import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { OneWayInService } from 'src/api/v2';
import { ONE_WAY_IN_STATISTICS } from 'src/constants/hook-keys';

const useOwiStatistics = () => {
  const [service] = useState(() => new OneWayInService());
  const owiStatisticsQuery = useQuery({
    queryKey: [ONE_WAY_IN_STATISTICS],
    queryFn: () => service.getPublicStatistics(),
    retry: false,
    staleTime: 1000 * 60 * 15,
    refetchOnMount: true,
  });

  return owiStatisticsQuery;
};

export default useOwiStatistics;
